<template>
   <div class='EnProgreso'>
    
    <div v-if="loading">
        <div class="d-flex justify-content-center mt-5">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
            
    <div v-else>
        <div v-if="projectos == null">
            <div class="row pt-3">
                <div class="col">
                    <div class="card">
                        <p class="text-center pt-2">Sin Proyectos</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <!-- Tabla -->
            <table class="table">
            <thead>
                <tr>
                    <th scope="col">Nombre Proyecto</th>
                    <th scope="col">Adjudicado a:</th>
                    <th scope="col">Monto</th>
                    <th scope="col">Fecha Cancelacion</th>
                    <th scope="col">Cancelado por:</th>
                    <th scope="col" style="width: 25%">Motivo Cancelación</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="f in projectos" :key="f.id">
                    <td>
                        <router-link :to="{ name: 'DetalleProyecto', params: { idEmpresa: f.id_proyecto}}"> 
                            {{f.titulo_proyecto}} 
                        </router-link>
                    </td>
                    <td>
                        <div class="row" v-if="f.usuario != null">
                            <div class="col-3">
                                <img :src="getUrl(f.avatar)" class="img">
                            </div>
                            <div class="col-9">
                                <router-link :to="{ name: 'calificacion', params: {id: f.id_user}}">
                                    @{{f.usuario}}
                                </router-link>
                                <star-rating :increment="0.1" :rating="makeNumber(f.estrellas)" :star-size="20" :show-rating="false" :read-only="true"/>
                            </div>
                        </div>
                        <div v-else>
                            Sin Adjudicar
                        </div>
                    </td>
                    <td>
                        ${{moneda(f.monto_proyecto)}} <small> (USD) </small><br>
                    </td>
                    <td>{{fechaFormat(f.fecha_cancelacion)}}</td>
                    <td>
                        <p v-if="f.quienCancelo == 1">Consultor</p>
                        <p v-else>Cliente</p>
                    </td>
                    <td>
                        <p v-if="f.razonCancelado.length > 0"> {{f.razonCancelado}} </p>
                        <p v-else>  --  </p>
                    </td>
                </tr>
            </tbody>
            </table>
        </div>
    </div>
   </div>
</template>


<script>
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'
import StarRating from 'vue-star-rating'

export default {
name: 'EnProgreso',
components:{StarRating},
mixins: [ globalFunctions ],
data () {
    return {
        projectos: [],
        loading: true
    }
},
methods: {
getData(){
    let data = {
        id: localStorage.userID,
        prop: 7,
        flag:0
    };

    this.axios.post(this.url + 'getProyectos.php',data).then((responce) =>{
        this.projectos = responce.data;
        this.loading = false;
        this.$emit("update");
    });
}
},
computed:{
    ...mapState(['url'])
},
mounted(){
    this.getData();
}
}
</script>


<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/Proyectos/components/Empresa/Cancelados.vue